"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePartialState = void 0;
var react_1 = require("react");
var object_1 = require("../object");
function usePartialState(initial) {
    var _a = __read((0, react_1.useState)(initial), 2), state = _a[0], setState = _a[1];
    function setPartial(value) {
        if (typeof value === 'function') {
            setState(function (v) { return (0, object_1.deepMerge)(v, value(v)); });
        }
        else {
            setState((0, object_1.deepMerge)(state, value));
        }
    }
    return [state, setPartial];
}
exports.usePartialState = usePartialState;
